export default {"src":"/_next/static/media/permission.2bab63a0.svg","height":50,"width":112,"blurWidth":0,"blurHeight":0};